import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, MapPinIcon } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';
import { Aura } from '../components/Aura';
export function Contact() {
  useScreenInit();
  return <div className="min-h-screen w-full bg-black text-white" data-id="element-190">
      <Navbar data-id="element-191" />
      <main className="relative overflow-hidden px-5 pb-24 pt-40 sm:px-8 sm:pt-48 lg:px-12" data-id="element-192">
        <Aura variant="soft" className="left-1/2 top-0 h-[45vh] w-[100vw] -translate-x-1/2 -translate-y-1/2" data-id="element-193" />

        <div className="relative z-10 mx-auto grid w-full max-w-7xl grid-cols-1 gap-16 lg:grid-cols-[1fr_1.2fr] lg:gap-24" data-id="element-194">
          {/* Left — headline + direct contact info */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-195">
            <span className="text-xs font-medium uppercase tracking-[0.35em] text-white/45" data-id="element-196">
              Contact Us
            </span>
            <h1 className="font-display mt-6 text-5xl uppercase leading-[0.95] tracking-[0.04em] text-white sm:text-7xl" data-id="element-197">
              Work
              <br data-id="element-198" />
              With Us
            </h1>
            <p className="mt-8 max-w-sm text-sm font-light leading-relaxed text-white/55 sm:text-base" data-id="element-199">
              Brands, influencers, and creators &mdash; tell us where you want
              to go. We&rsquo;ll get you licensed, packaged, and on shelves at
              the biggest retailers in the country.
            </p>

            <div className="mt-12 flex flex-col gap-5" data-id="element-200">
              <a href="mailto:hello@aenigma.co" className="group inline-flex items-center gap-4 text-sm text-white/60 transition-colors hover:text-white" data-id="element-201">
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-colors group-hover:border-white/50" data-id="element-202">
                  <MailIcon className="h-4 w-4" data-id="element-203" />
                </span>
                hello@aenigma.co
              </a>
              <span className="inline-flex items-center gap-4 text-sm text-white/60" data-id="element-204">
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20" data-id="element-205">
                  <MapPinIcon className="h-4 w-4" data-id="element-206" />
                </span>
                Los Angeles &middot; New York
              </span>
            </div>
          </motion.div>

          {/* Right — form */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.25,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-207">
            <ContactForm data-id="element-208" />
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-209" />
    </div>;
}